var contentful = require('./contentful')
module.exports = function () {
  return contentful
}



/** WEBPACK FOOTER **
 ** ./components/contentfulWrapper/index.js
 **/